import styled from 'styled-components';


const StyledStatsTable = styled.div`
  .stats-view--header {
    font-size: 1.325em;
    font-weight: bold;
    margin-bottom: 14px;
  }

  .stats-view--input-label {
    font-weight: 700;
    font-size: 0.9em;
  }

  .stats-view--input {
    max-width: 500px;
  }

  .stats-view--table--laoder {
    position: relative;
    height: 80px;
  }

  .stats-view--table--data {
    min-height: 80px;
  }

  .stats-view--table--header--wrapper {
    margin-top: 7px;
  }

  .stats-view--table--header {
    margin-right: 0;
    margin-left: 0;
    box-sizing: border-box;
    border-bottom: 2px solid #ccc;
  }

  .stats-view--table--header-item {
    text-align: right;
    padding-right: 7px;
    padding-left: 7px;
    font-weight: 700;
  }

    .stats-view--table--name {
    text-align: left;
  }

  .stats-view--table--header-sm {
    display: none;
  }

  .stats-view--table--row {
    margin-right: 0;
    margin-left: 0;
    box-sizing: border-box;

    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
  }

  .stats-view--table--row--even {
    background: #f4f4f4;
  }

  .stats-view--table--item {
    padding-right: 7px;
    padding-left: 7px;
    text-align: right;
    width: unset;
  }

  .stats-view--table--id {
    display: inline-block;
    width: 4%;
    text-align: left;
  }

  .stats-view--table--name {
    display: inline-block;
    width: 24%;
    text-align: left;
  }

  .stats-view--table--desk {
    display: inline-block;
    width: 12%;
  }

  .stats-view--table--clients {
    display: inline-block;
    width: 12%;
  }

  .stats-view--table--max-len {
    display: inline-block;
    width: 12%;
  }

  .stats-view--table--wait-cli {
    display: inline-block;
    width: 12%;
  }

  .stats-view--table--wait-avg {
    display: inline-block;
    width: 12%;
  }

  .stats-view--table--last {
    display: inline-block;
    width: 12%;
  }


  @media (max-width: 992px) {
    .stats-view--table--item {
      text-align: left;
      width: 100%;
    }
    
    .stats-view--table--header {
      display: none;
    }

    .stats-view--table--header-sm {
      display: block;
      font-size: 0.9em;
      font-weight: 700;
      padding-right: 7px;
      padding-left: 7px;
    }

    .stats-view--table--row {
      display: block;
      -ms-flex-wrap: unset;
      flex-wrap: unset;
      box-sizing: border-box;
    }

    .stats-view--table--id {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;
    }

    .stats-view--table--name {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;
    }

    .stats-view--table--desk {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }

    .stats-view--table--clients {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }

    .stats-view--table--max-len {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }

    .stats-view--table--wait-cli {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }

    .stats-view--table--wait-avg {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }

    .stats-view--table--last {
      max-width: 100%;
      -ms-flex: unset;
      flex: unset;    
    }
  }

  @media print {
    .stats-view--header {
    font-size: 1em;
    font-weight: bold;
    margin-bottom: 14px;
    color: red;
  }

  .stats-view--input-label {
    font-weight: 700;
    font-size: 0.9em;
  }

  .stats-view--input {
    max-width: 500px;
  }

  .stats-view--table--laoder {
    position: relative;
    height: 80px;
  }

  .stats-view--table--data {
    border: 2px solid #ccc;
    font-size: 0.85em;
  }

  .stats-view--table--header--wrapper {
    font-size: 0.9em;
    border: 2px solid #ccc;
    border-bottom: none;
  }

  .stats-view--table--header {
    display: block;
    border-bottom: 2px solid #ccc;
  }

  .stats-view--table--header-item {
    text-align: right;
    padding-right: 7px;
    padding-left: 7px;
    font-weight: 700;
  }

    .stats-view--table--name {
    text-align: left;
  }

  .stats-view--table--header-sm {
    display: none;
  }

  .stats-view--table--row {
    margin-right: 0;
    margin-left: 0;
    box-sizing: border-box;

    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
  }

  .stats-view--table--row--even {
    background: #f4f4f4;
  }

  .stats-view--table--item {
    padding-right: 7px;
    padding-left: 7px;
    text-align: right;
    width: unset;
  }

  .stats-view--table--id {
    display: inline-block;
    width: 4%;
    text-align: left;
  }

  .stats-view--table--name {
    display: inline-block;
    width: 36%;
    text-align: left;
  }

  .stats-view--table--desk {
    display: inline-block;
    width: 10%;
  }

  .stats-view--table--clients {
    display: inline-block;
    width: 10%;
  }

  .stats-view--table--max-len {
    display: inline-block;
    width: 10%;
  }

  .stats-view--table--wait-cli {
    display: inline-block;
    width: 10%;
  }

  .stats-view--table--wait-avg {
    display: inline-block;
    width: 10%;
  }

  .stats-view--table--last {
    display: inline-block;
    width: 10%;
  }
  }
`;

export default StyledStatsTable;
